var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 19,
    viewBox: "0 0 10 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66656 18.5792V10.3832H9.43156L9.84256 7.1742H6.66656V5.1302C6.66656 4.2042 6.92456 3.5702 8.25356 3.5702H9.93756V0.709201C9.1182 0.621391 8.29461 0.578993 7.47056 0.5822C5.02656 0.5822 3.34856 2.0742 3.34856 4.8132V7.1682H0.601562V10.3772H3.35456V18.5792H6.66656Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.bdb9b39e7172cbfe69cf04ee37544398.svg";
export { ForwardRef as ReactComponent };